/**
 * 通讯监测接口
 */
import Axios from '@/components/api/axios.js'

export default {
	/*
	 * 添加采集平台对应的通道(根据采集平台固定通道名称)
	 */
	addChannelForIOT(success, failure) {
		Axios.post('/channel/addChannelForIOT.do', {}, success, failure)
	},
	/*
	 * 添加通道（自定义通道名称）
	 */
	addChannel(name, success, failure) {
		Axios.post('/channel/addChannel.do', {
			name,
		}, success, failure)
	},
	/*
	 * 分页获取通道列表
	 */
	getChannelLimit(pageIndex, pageSize, success, failure) {
		Axios.post('/channel/getChannelLimit.do', {
			pageIndex,
			pageSize
		}, success, failure)
	},
	/*
	 * 根据通道id分页获取对应设备列表
	 */
	getDeviceByChannelLimit(channel, pageIndex, pageSize, success, failure) {
		Axios.post('/channel/getDeviceByChannelLimit.do', {
			channel,
			pageIndex,
			pageSize
		}, success, failure)
	},
	/*
	 * 根据设备id分页获取对应变量列表
	 */
	getGenerallyVariableByDeviceNoLimit(deviceNo, pageIndex, pageSize, success, failure) {
		Axios.post('/channel/getGenerallyVariableByDeviceNoLimit.do', {
			deviceNo,
			pageIndex,
			pageSize
		}, success, failure)
	},

}